import { SvgIcon } from '@material-ui/core'

export default (props) => (
  <SvgIcon {...props} viewBox='0 0 1000 1000'>
    <path d='m202.5625,851.4375l630,-630q10,-11 13,-21t-2,-16l-28,-28q-5,-5 -15,-2t-21,13l-631,630q-10,11 -13,22t2,15l28,28q5,5 16,2t21,-13zm654,-708q-7,-8 -19,-8l-195,-1q-11,0 -18,8t-8,19l0,22q0,12 8,20t19,8l145,0l1,145q0,12 8,20t19,7l22,0q11,1 19,-7t8,-19l-1,-195q0,-11 -8,-19z' />
  </SvgIcon>
)
